import { Grid } from "@material-ui/core";
import { getValueToIconMapForHazard } from "../map/HazardSelectorHelper";
import { getValueToIconMapForKPI } from "../map/KPISelectorHelper";
import { useTranslation } from "react-i18next";
import { capitalizeFirstLetter } from "../util/tableUtils";
import { bivariateKpiThresholds } from "../map/BivariateLogic";

const garanziasHowden = {
  anyhazard: [
    "D01 : Fire and explosion",
    "D02 : Electrical equipment damage",
    "D03 : Precipitation damage (rain/snow)",
    "D04 : Wind, hail and glass damage",
    "D05 : Snow load damage",
    "D06 : Flood and flash flood",
    "D08 : Structural collapse",
    "D09 : Indirect losses (downtime)",
    "D10 : Roof damage",
  ],
  lightning: [
    "D01 : Fire and explosion",
    "D02 : Electrical equipment damage",
    "D09 : Indirect losses (downtime)",
  ],
  snow: [
    "D03 : Precipitation damage (rain/snow)",
    "D05 : Snow load damage",
    "D06 : Flood and flash flood",
    "D08 : Structural collapse",
    "D09 : Indirect losses (downtime)",
    "D10 : Roof damage",
  ],
  rain: [
    "D03 : Precipitation damage (rain/snow)",
    "D06 : Flood and flash flood",
    "D08 : Structural collapse",
    "D09 : Indirect losses (downtime)",
  ],
  wind: [
    "D04 : Wind, hail and glass damage",
    "D08 : Structural collapse",
    "D09 : Indirect losses (downtime)",
    "D10 : Roof damage",
  ],
  hail: ["D04 : Wind, hail and glass damage", "D09 : Indirect losses (downtime)", "D10 : Roof damage"],
  inland_flood: [
    "D06 : Flood and flash flood",
    "D08 : Structural collapse",
    "D09 : Indirect losses (downtime)",
  ],
  earthquake: ["D08 : Structural collapse", "D09 : Indirect losses (downtime)"],
};
const garanziasRealRisk =
  // This is the list of garanzias that are related to each hazard.
  // Used as helper, it has no effect on the map and tables.
  // It should be in sync with harazdlist column which was createed in
  // C:\dev\cys-realerisk-sftp-py-service\notebooks\realerisk_mongodb_dbclimate_analyticssplit.ipynb,
  // see cells that mention version v2,v3.
  // The code below is printed to legend.js

  // OLD:
  // For version v1 (the first version with colored boxes)
  // It is created in file
  // cys-realerisk-analytics-datavalidation\notebooks\garanzia-perils-short-report_v1.json
  // when you rerun cys-realerisk-analytics-datavalidation\notebooks\11_hazard_peril_reader_v1.ipynb

  {
    anyhazard: [
      "ACQUA CONDOTTA",
      "ACQUA CONDOTTA/OCCLUS.",
      "ACQUA CONDOTTA/OCCLUSIONI",
      "ACQUA PIOVANA",
      "ACQUA PIOVANA VENTO GRANDINE ELEM.FRAGI",
      "ALTRE GARANZIE INCENDIO",
      "ALTRE PARTITE FABBRICATO",
      "APPARECCHIATURE ELETTRONICHE",
      "ARCHIVI O DOCUMENTI",
      "ARREDAMENTO",
      "BENI ASS A CONDIZIONI SPECIALI",
      "COLAGGIO, ACQUA DA IMPIANTI ESTENZIONE",
      "CONTENUTO",
      "CRISTALLI GAR.BASE",
      "DANNI ELETTRICI",
      "DANNI INDIRETTI (ALL RISKS)",
      "DANNI INDIRETTI A %",
      "EV.SOC./POL.ED ATMOSF.",
      "EVENTI ATMOSFERICI",
      "EVENTI ATMOSFERICI NEVE",
      "EVENTI SOCIOPOLITICI ED ATMOSFERICI",
      "FABBRICATO",
      "FABBRICATO ALLUVIONI",
      "FABBRICATO O RISC.LOCAT.",
      "FABBRICATO TERREMOTO",
      "FENOMENO ELETTRICO",
      "FENOMENO ELETTRICO NUOVE % AZIENDA 2016",
      "GARANZIA FITTIZIA SU RAMO 10",
      "GARANZIA FITTIZIA SU RAMO 18",
      "GARANZIA LIBERA",
      "GELO E SOVRACCARICO NEVE",
      "GRANDINE",
      "GRANDINE SU ELEMENTI FRAGILI (GLOB.FABBR.2014)",
      "GRANDINE SU GRANAGLIE (AGRIREALE)",
      "GUASTI ELETTRICI",
      "Generica migrazione ex-Uniqa",
      "IMPIANTI FOTOVOLTAICI - SOLARI TERMICI",
      "INDENNITA' AGGIUNTIVA ALLUVIONI",
      "INDENNITA' AGGIUNTIVA TERREMOTO",
      "INONDAZ/ALLUV/ALLAGAM CONTENUTO",
      "INONDAZ/ALLUV/ALLAGAM FABBRICATO",
      "INONDAZIONE, ALLUVIONE, ALLAGAMENTO",
      "INONDAZIONE/ALLUVIONE/ALLAGAMENTO",
      "INONDAZIONE/ALLUVIONE/ALLAGAMENTO ESENTE",
      "INONDAZIONI/ALLUV/ALLAG.",
      "MACCHINARIO/ATTREZ./IMP.",
      "MACCHINE AGRICOLE",
      "MANCATO FREDDO/FUOR.FLU.",
      "MERCI FISSE",
      "MERCI FLOTTANTI",
      "MERCI IN REFRIGERAZIONE",
      "PIE-VENTO E GRANDINE",
      "SOCIOP/GRA/TERR/VEICOLI ALL'APERTO",
      "SOMMA ASSICURATA COMPLESSIVA",
      "SOVRACCARICO NEVE",
      "TERREMOTO",
      "TERREMOTO ALTRE PARTITE ELETTRONICA",
      "TERREMOTO APP. ELETTRICHE/ELETTRONICHE",
      "TERREMOTO CONTENUTO",
      "TERREMOTO FABBRICATO",
      "TERREMOTO/MAREMOTO/ERUZ. VULCANICA",
      "TERREMOTO/MAREMOTO/ERUZ.VULCANICA",
      "TERREMOTO/MAREMOTO/ERUZIONE VULC.ESENTE",
      "TERREMOTO/MAREMOTO/ERUZIONE VULCANICA",
      "TERREMOTO/MAREMOTO/ERUZIONI VULCANICHE",
      "VENTO E GRANDINE",
      "VENTO E GRANDINE SU FRAGILI",
    ],
    wind: [
      "ACQUA PIOVANA VENTO GRANDINE ELEM.FRAGI",
      "ALTRE GARANZIE INCENDIO",
      "ALTRE PARTITE FABBRICATO",
      "APPARECCHIATURE ELETTRONICHE",
      "ARCHIVI O DOCUMENTI",
      "ARREDAMENTO",
      "BENI ASS A CONDIZIONI SPECIALI",
      "COLAGGIO, ACQUA DA IMPIANTI ESTENZIONE",
      "CONTENUTO",
      "DANNI INDIRETTI (ALL RISKS)",
      "DANNI INDIRETTI A %",
      "EV.SOC./POL.ED ATMOSF.",
      "EVENTI ATMOSFERICI",
      "EVENTI ATMOSFERICI NEVE",
      "EVENTI SOCIOPOLITICI ED ATMOSFERICI",
      "FABBRICATO",
      "FABBRICATO O RISC.LOCAT.",
      "GARANZIA FITTIZIA SU RAMO 10",
      "GARANZIA LIBERA",
      "Generica migrazione ex-Uniqa",
      "IMPIANTI FOTOVOLTAICI - SOLARI TERMICI",
      "MACCHINARIO/ATTREZ./IMP.",
      "MACCHINE AGRICOLE",
      "MERCI FISSE",
      "MERCI FLOTTANTI",
      "MERCI IN REFRIGERAZIONE",
      "PIE-VENTO E GRANDINE",
      "SOCIOP/GRA/TERR/VEICOLI ALL'APERTO",
      "SOMMA ASSICURATA COMPLESSIVA",
      "VENTO E GRANDINE",
      "VENTO E GRANDINE SU FRAGILI",
    ],
    hail: [
      "ACQUA PIOVANA VENTO GRANDINE ELEM.FRAGI",
      "ALTRE GARANZIE INCENDIO",
      "ALTRE PARTITE FABBRICATO",
      "APPARECCHIATURE ELETTRONICHE",
      "ARCHIVI O DOCUMENTI",
      "ARREDAMENTO",
      "BENI ASS A CONDIZIONI SPECIALI",
      "COLAGGIO, ACQUA DA IMPIANTI ESTENZIONE",
      "CONTENUTO",
      "CRISTALLI GAR.BASE",
      "DANNI INDIRETTI (ALL RISKS)",
      "DANNI INDIRETTI A %",
      "EV.SOC./POL.ED ATMOSF.",
      "EVENTI ATMOSFERICI",
      "EVENTI ATMOSFERICI NEVE",
      "EVENTI SOCIOPOLITICI ED ATMOSFERICI",
      "FABBRICATO",
      "FABBRICATO O RISC.LOCAT.",
      "GARANZIA FITTIZIA SU RAMO 10",
      "GARANZIA LIBERA",
      "GRANDINE",
      "GRANDINE SU ELEMENTI FRAGILI (GLOB.FABBR.2014)",
      "GRANDINE SU GRANAGLIE (AGRIREALE)",
      "Generica migrazione ex-Uniqa",
      "IMPIANTI FOTOVOLTAICI - SOLARI TERMICI",
      "MACCHINARIO/ATTREZ./IMP.",
      "MACCHINE AGRICOLE",
      "MERCI FISSE",
      "MERCI FLOTTANTI",
      "PIE-VENTO E GRANDINE",
      "SOCIOP/GRA/TERR/VEICOLI ALL'APERTO",
      "SOMMA ASSICURATA COMPLESSIVA",
      "VENTO E GRANDINE",
      "VENTO E GRANDINE SU FRAGILI",
    ],
    snow: [
      "ALTRE GARANZIE INCENDIO",
      "ALTRE PARTITE FABBRICATO",
      "APPARECCHIATURE ELETTRONICHE",
      "ARCHIVI O DOCUMENTI",
      "ARREDAMENTO",
      "BENI ASS A CONDIZIONI SPECIALI",
      "COLAGGIO, ACQUA DA IMPIANTI ESTENZIONE",
      "CONTENUTO",
      "DANNI INDIRETTI (ALL RISKS)",
      "DANNI INDIRETTI A %",
      "EVENTI ATMOSFERICI NEVE",
      "FABBRICATO",
      "FABBRICATO O RISC.LOCAT.",
      "GARANZIA FITTIZIA SU RAMO 10",
      "GARANZIA LIBERA",
      "GELO E SOVRACCARICO NEVE",
      "Generica migrazione ex-Uniqa",
      "IMPIANTI FOTOVOLTAICI - SOLARI TERMICI",
      "MACCHINARIO/ATTREZ./IMP.",
      "MACCHINE AGRICOLE",
      "MANCATO FREDDO/FUOR.FLU.",
      "MERCI FISSE",
      "MERCI FLOTTANTI",
      "MERCI IN REFRIGERAZIONE",
      "SOMMA ASSICURATA COMPLESSIVA",
      "SOVRACCARICO NEVE",
    ],
    lightning: [
      "ALTRE GARANZIE INCENDIO",
      "ALTRE PARTITE FABBRICATO",
      "APPARECCHIATURE ELETTRONICHE",
      "ARCHIVI O DOCUMENTI",
      "ARREDAMENTO",
      "BENI ASS A CONDIZIONI SPECIALI",
      "COLAGGIO, ACQUA DA IMPIANTI ESTENZIONE",
      "CONTENUTO",
      "DANNI ELETTRICI",
      "DANNI INDIRETTI (ALL RISKS)",
      "DANNI INDIRETTI A %",
      "FABBRICATO",
      "FABBRICATO O RISC.LOCAT.",
      "FENOMENO ELETTRICO",
      "FENOMENO ELETTRICO NUOVE % AZIENDA 2016",
      "GARANZIA FITTIZIA SU RAMO 10",
      "GARANZIA FITTIZIA SU RAMO 18",
      "GARANZIA LIBERA",
      "GUASTI ELETTRICI",
      "Generica migrazione ex-Uniqa",
      "IMPIANTI FOTOVOLTAICI - SOLARI TERMICI",
      "MACCHINARIO/ATTREZ./IMP.",
      "MACCHINE AGRICOLE",
      "MANCATO FREDDO/FUOR.FLU.",
      "MERCI FISSE",
      "MERCI FLOTTANTI",
      "MERCI IN REFRIGERAZIONE",
      "SOMMA ASSICURATA COMPLESSIVA",
    ],
    earthquake: [
      "ALTRE GARANZIE INCENDIO",
      "ALTRE PARTITE FABBRICATO",
      "APPARECCHIATURE ELETTRONICHE",
      "ARCHIVI O DOCUMENTI",
      "ARREDAMENTO",
      "BENI ASS A CONDIZIONI SPECIALI",
      "COLAGGIO, ACQUA DA IMPIANTI ESTENZIONE",
      "CONTENUTO",
      "DANNI INDIRETTI (ALL RISKS)",
      "DANNI INDIRETTI A %",
      "FABBRICATO",
      "FABBRICATO O RISC.LOCAT.",
      "FABBRICATO TERREMOTO",
      "GARANZIA FITTIZIA SU RAMO 10",
      "GARANZIA LIBERA",
      "Generica migrazione ex-Uniqa",
      "INDENNITA' AGGIUNTIVA TERREMOTO",
      "MACCHINARIO/ATTREZ./IMP.",
      "MACCHINE AGRICOLE",
      "MANCATO FREDDO/FUOR.FLU.",
      "MERCI FISSE",
      "MERCI FLOTTANTI",
      "MERCI IN REFRIGERAZIONE",
      "SOMMA ASSICURATA COMPLESSIVA",
      "TERREMOTO",
      "TERREMOTO ALTRE PARTITE ELETTRONICA",
      "TERREMOTO APP. ELETTRICHE/ELETTRONICHE",
      "TERREMOTO CONTENUTO",
      "TERREMOTO FABBRICATO",
      "TERREMOTO/MAREMOTO/ERUZ. VULCANICA",
      "TERREMOTO/MAREMOTO/ERUZ.VULCANICA",
      "TERREMOTO/MAREMOTO/ERUZIONE VULC.ESENTE",
      "TERREMOTO/MAREMOTO/ERUZIONE VULCANICA",
      "TERREMOTO/MAREMOTO/ERUZIONI VULCANICHE",
    ],
    rain: [
      "ACQUA CONDOTTA",
      "ACQUA CONDOTTA/OCCLUS.",
      "ACQUA CONDOTTA/OCCLUSIONI",
      "ACQUA PIOVANA",
      "ACQUA PIOVANA VENTO GRANDINE ELEM.FRAGI",
      "ALTRE PARTITE FABBRICATO",
      "APPARECCHIATURE ELETTRONICHE",
      "ARCHIVI O DOCUMENTI",
      "ARREDAMENTO",
      "BENI ASS A CONDIZIONI SPECIALI",
      "COLAGGIO, ACQUA DA IMPIANTI ESTENZIONE",
      "CONTENUTO",
      "DANNI INDIRETTI (ALL RISKS)",
      "DANNI INDIRETTI A %",
      "FABBRICATO",
      "FABBRICATO O RISC.LOCAT.",
      "GARANZIA FITTIZIA SU RAMO 10",
      "Generica migrazione ex-Uniqa",
      "MACCHINARIO/ATTREZ./IMP.",
      "MACCHINE AGRICOLE",
      "MERCI FISSE",
      "MERCI FLOTTANTI",
      "SOMMA ASSICURATA COMPLESSIVA",
    ],
    inland_flood: [
      "ALTRE GARANZIE INCENDIO",
      "ALTRE PARTITE FABBRICATO",
      "APPARECCHIATURE ELETTRONICHE",
      "ARCHIVI O DOCUMENTI",
      "ARREDAMENTO",
      "BENI ASS A CONDIZIONI SPECIALI",
      "COLAGGIO, ACQUA DA IMPIANTI ESTENZIONE",
      "CONTENUTO",
      "DANNI INDIRETTI (ALL RISKS)",
      "DANNI INDIRETTI A %",
      "FABBRICATO",
      "FABBRICATO ALLUVIONI",
      "FABBRICATO O RISC.LOCAT.",
      "GARANZIA FITTIZIA SU RAMO 10",
      "GARANZIA LIBERA",
      "Generica migrazione ex-Uniqa",
      "INDENNITA' AGGIUNTIVA ALLUVIONI",
      "INONDAZ/ALLUV/ALLAGAM CONTENUTO",
      "INONDAZ/ALLUV/ALLAGAM FABBRICATO",
      "INONDAZIONE, ALLUVIONE, ALLAGAMENTO",
      "INONDAZIONE/ALLUVIONE/ALLAGAMENTO",
      "INONDAZIONE/ALLUVIONE/ALLAGAMENTO ESENTE",
      "INONDAZIONI/ALLUV/ALLAG.",
      "MACCHINARIO/ATTREZ./IMP.",
      "MACCHINE AGRICOLE",
      "MANCATO FREDDO/FUOR.FLU.",
      "MERCI FISSE",
      "MERCI FLOTTANTI",
      "MERCI IN REFRIGERAZIONE",
      "SOMMA ASSICURATA COMPLESSIVA",
    ],
    landslide: [],
  };
// Here we expect in Table V3:
// ncat=(snow+hail+wind+flood), nat=(wind+hail), catastr=(earthquake+lanslide+inlandFlood),
// inland_flood=alluvione, landslide=(toBeDecided).

const configForGaranzias = { howden: garanziasHowden, realeRisk: garanziasRealRisk };

if (!configForGaranzias[process.env.REACT_APP_ENVIRONMENT]) {
  alert(
    `Environment ${process.env.REACT_APP_ENVIRONMENT} not found in configForGaranzias : ${Object.keys(configForGaranzias)}`,
  );
}

const garanziasBase = configForGaranzias[process.env.REACT_APP_ENVIRONMENT];

const garanzias = {
  ...garanziasBase,
  aniaWindstorm: garanziasBase.wind,
  aniaLightning: garanziasBase.lightning,
  aniaPrecipitation: garanziasBase.rain, // meaning rain / pioggia
  aniaHail: garanziasBase.hail,
  aniaSnow: garanziasBase.snow,
  realeGroupHail: garanziasBase.hail,
  realeGroupWind: garanziasBase.wind,
  howdenWeightedInlandFlood202410: garanziasBase.inland_flood,

  cysNcat: [
    ...new Set(garanziasBase.wind.concat(garanziasBase.hail, garanziasBase.rain, garanziasBase.snow)),
  ],
  aniaNcat: [
    ...new Set(garanziasBase.wind.concat(garanziasBase.hail, garanziasBase.rain, garanziasBase.snow)),
  ],

  cysNat: [...new Set(garanziasBase.wind.concat(garanziasBase.hail))],
  aniaNat: [...new Set(garanziasBase.wind.concat(garanziasBase.hail))],
  weatherindex: [...new Set(garanziasBase.wind.concat(garanziasBase.hail))],
  cysCatastr: [
    ...new Set(garanziasBase.earthquake.concat(garanziasBase.landslide, garanziasBase.inland_flood)),
  ],
  aniaCatastr: [
    ...new Set(garanziasBase.earthquake.concat(garanziasBase.landslide, garanziasBase.inland_flood)),
  ],
};

export const hazardGaranzias = (hazardSelect, KPISelect) => {
  let retHazardGaranzias = "";

  if (hazardSelect !== "none") {
    if (!garanzias[hazardSelect]) {
      console.error(`hazardSelect ${hazardSelect} not found in garanzias `, garanzias);
    }
    retHazardGaranzias = JSON.stringify(
      garanzias[hazardSelect]
        .map((garanzia) => capitalizeFirstLetter(garanzia))

        .sort(),
    ).replace(/,/g, ", ");
  }
  return retHazardGaranzias;
};

export const BivariateLegend = ({ hazardSelect, KPISelect, wantedReferenceDateProp }) => {
  const { t } = useTranslation();

  const limits = bivariateKpiThresholds("ClimateAnalytics");

  let explain = "";
  let hazardDetail = "";
  let hazardLevels = "";
  let KPIDetail = "";
  let KPILevels = "";

  const lowMediumHigh = `${t("analyticsLegend.white")} = ${t("levels.low")},  ${t(
    "analyticsLegend.pink",
  )} = ${t("levels.medium")},  ${t("analyticsLegend.red")} =  ${t("levels.high")}`;

  if (hazardSelect === "earthquake") {
    hazardDetail = t("riskExposureMapExplained.seismicClassification");
    hazardLevels = `${t("analyticsLegend.white")} =${t("analyticsLegend.zone")}  4,  pink=${t(
      "analyticsLegend.zone",
    )}  3,  ${t("analyticsLegend.red")} =${t("analyticsLegend.zone")}  1 and ${t("analyticsLegend.zone")}  2`;
  }

  if (hazardSelect === "hail") {
    hazardDetail = t("riskExposureMapExplained.hailItaLarge", {
      size: t("riskExposureMapExplained.large"),
      mm: 20,
      scenario: "",
    });
    hazardLevels = `${t("analyticsLegend.white")} : <= 0.019,  ${t(
      "analyticsLegend.pink",
    )} : 0.020-0.039,  ${t("analyticsLegend.red")} : >= 0.040 ${t("analyticsLegend.probabilityFraction")} `;
  }

  if (hazardSelect === "snow") {
    hazardDetail = t("riskExposureMapExplained.snowIta", { cm: 5 });
    hazardLevels = `${t("analyticsLegend.white")} : <20,  ${t("analyticsLegend.pink")} : 20-70,  ${t(
      "analyticsLegend.red",
    )} : >70  ${t("analyticsLegend.probabilityPercents")}`;
  }

  if (hazardSelect === "lightning") {
    hazardDetail = t("riskExposureMapExplained.lightningStrike");
    hazardLevels = `${t("analyticsLegend.white")} : <8.5,  ${t("analyticsLegend.pink")} : 8.5-17,  ${t(
      "analyticsLegend.red",
    )} : >17 events/km2/year`;
  }

  if (hazardSelect === "wind") {
    hazardDetail = t("riskExposureMapExplained.windSevere");
    hazardLevels = `${t("analyticsLegend.white")} <=0.36,  ${t("analyticsLegend.pink")} :0.37-0.85,  ${t(
      "analyticsLegend.red",
    )} : >=0.86 ${t("analyticsLegend.probabilityFraction")} `;
  }

  if (hazardSelect === "rain") {
    hazardDetail = t("riskExposureMapExplained.flashFloodIta", { hour: 24 });

    hazardLevels = `${t("analyticsLegend.white")} : <=3.06,  ${t("analyticsLegend.pink")} : 3.07-4.84,  ${t(
      "analyticsLegend.red",
    )} : >=4.85 mm/hour`;
  }

  if (hazardSelect === "weatherindex") {
    hazardDetail = t("analyticsLegend.weatherIndex");

    hazardLevels = `${t("analyticsLegend.white")} <0.5,  ${t("analyticsLegend.pink")} =0.5-1.5,  ${t(
      "analyticsLegend.red",
    )} >1.5`;
  }

  if (hazardSelect === "aniaWindstorm") {
    hazardDetail = t("aniaTooltip.windHazard") + t("aniaTooltip.processed");
    hazardLevels = lowMediumHigh;
  }

  if (hazardSelect === "aniaLightning") {
    hazardDetail = t("aniaTooltip.lightningStrike") + t("aniaTooltip.processed");
    hazardLevels = lowMediumHigh;
  }

  if (hazardSelect === "aniaPrecipitation") {
    hazardDetail = t("aniaTooltip.precipitation") + t("aniaTooltip.processed");
    hazardLevels = lowMediumHigh;
  }

  if (hazardSelect === "aniaHail") {
    hazardDetail = t("aniaTooltip.hail") + t("aniaTooltip.processed");
    hazardLevels = lowMediumHigh;
  }

  if (hazardSelect === "aniaSnow") {
    hazardDetail = t("aniaTooltip.precipitationSnow") + t("aniaTooltip.processed");
    hazardLevels = lowMediumHigh;
  }

  if (hazardSelect === "aniaNcat") {
    hazardDetail = t("climateIndex.AniaNcat") + t("climateIndex.AniaNcatLegend") + t("aniaTooltip.processed");
    hazardLevels = lowMediumHigh;
  }

  if (hazardSelect === "aniaNat") {
    hazardDetail = t("climateIndex.AniaNe") + t("climateIndex.AniaNeLegend") + t("aniaTooltip.processed");
    hazardLevels = lowMediumHigh;
  }

  if (hazardSelect === "realeGroupHail") {
    hazardDetail =
      t("riskExposureMapExplained.realeGroupHail") + t("riskExposureMapExplained.realeGroupProcessed");
    hazardLevels = `${t("analyticsLegend.white")} : zone 1-2;  ${t("analyticsLegend.pink")} :zone 3-4;  ${t(
      "analyticsLegend.red",
    )} :zone 5-6`;
  }

  if (hazardSelect === "realeGroupWind") {
    hazardDetail =
      t("riskExposureMapExplained.realeGroupWind") + t("riskExposureMapExplained.realeGroupProcessed");
    hazardLevels = `${t("analyticsLegend.white")} : zone 1-2;  ${t("analyticsLegend.pink")} :zone 3;  ${t(
      "analyticsLegend.red",
    )} :zone 4-5`;
  }

  if (hazardSelect === "howdenWeightedInlandFlood202410") {
    hazardDetail =
      t("riskExposureMapExplained.howdenWeightedInlandFlood") +
      t("riskExposureMapExplained.realeGroupProcessed") +
      " 202410";
    hazardLevels = `${t("analyticsLegend.white")} : zone 0-1;  ${t("analyticsLegend.pink")} :zone 2-3;  ${t(
      "analyticsLegend.red",
    )} :zone 4-10`;
  }

  if (hazardSelect === "cysNcat") {
    hazardDetail = t("climateIndex.CysNcat") + t("climateIndex.CysNcatLegend");
    hazardLevels = `${t("analyticsLegend.white")} <33,  ${t("analyticsLegend.pink")} =33-66,  ${t(
      "analyticsLegend.red",
    )} >66`;
  }

  if (hazardSelect === "cysNat") {
    hazardDetail = t("climateIndex.CysNe") + t("climateIndex.CysNeLegend");
    hazardLevels = `${t("analyticsLegend.white")} <33,  ${t("analyticsLegend.pink")} =33-66,  ${t(
      "analyticsLegend.red",
    )} >66`;
  }

  if (KPISelect === "policyNumber") {
    KPIDetail = t("analyticsLegend.kpiPolicies");
    KPILevels = `${t("analyticsLegend.white")} =0-29,  ${t("analyticsLegend.blue")} =30-199,  ${t(
      "analyticsLegend.darkBlue",
    )} =200+`;
  }

  if (KPISelect === "accruedRisk") {
    KPIDetail = t("analyticsLegend.kpiRiskYears");

    KPILevels = `${t("analyticsLegend.white")} =0-29,  ${t("analyticsLegend.blue")} =30-199,  ${t(
      "analyticsLegend.darkBlue",
    )} =200+`;
  }

  if (KPISelect === "postrenewalValueFinal") {
    KPIDetail = t("analyticsLegend.kpiTIV");

    const limitLow = Math.floor(limits.postrenewalValueFinal.low2Moderate / 1000000);
    const limitHigh = Math.floor(limits.postrenewalValueFinal.moderate2High / 1000000);

    KPILevels = `${t("analyticsLegend.white")} =€ 0-${limitLow} M,   ${t("analyticsLegend.blue")} =€ ${limitLow + 1}-${limitHigh} M,  ${t(
      "analyticsLegend.darkBlue",
    )} =€ ${limitHigh + 1}+ M`;
  }

  if (hazardSelect === "anyhazard" && KPISelect === "none") {
    explain = `${t("analyticsLegend.seeRiskYears")}`;
  }

  if (hazardSelect !== "anyhazard" && KPISelect === "none") {
    explain = `${t("analyticsLegend.seeRiskLevel")}`;
  }

  if (hazardSelect === "anyhazard" && KPISelect !== "none") {
    explain = `${t("analyticsLegend.seeAllHazards")}`;
  }

  if (hazardSelect !== "anyhazard" && KPISelect !== "none") {
    explain = `${t("analyticsLegend.seeBivariate")}`;
  }

  if (hazardSelect !== "anyhazard" || KPISelect !== "none") {
    explain += " " + t("analyticsLegend.mapAffected");
  }
  const variantProp = "ClimateAnalytics";
  return (
    <Grid item xs={12} sm={12}>
      <div style={{ height: 300, width: "100%" }}>
        <h1>Legend</h1>

        <ul>
          {" "}
          <li>
            {t("analyticsLegend.hazardIs")} <b>&apos;{getValueToIconMapForHazard(hazardSelect).text}&apos;</b>{" "}
            {t("analyticsLegend.andKpiIs")}{" "}
            <b>&apos;{getValueToIconMapForKPI(KPISelect, variantProp).text}&apos;</b>.
          </li>
          <li>{explain}</li>
          {hazardDetail !== "" && (
            <li>
              {t("analyticsLegend.hazardDetails")}: {hazardDetail}{" "}
            </li>
          )}
          {hazardLevels !== "" && (
            <li>
              {t("analyticsLegend.hazardLevels")}: {hazardLevels}
            </li>
          )}
          {KPIDetail !== "" && (
            <li>
              {t("analyticsLegend.kpiDetails")}: {KPIDetail}{" "}
            </li>
          )}
          {KPILevels !== "" && (
            <li>
              {t("analyticsLegend.kpiLevels")}: {KPILevels}
            </li>
          )}
          {hazardGaranzias(hazardSelect, KPISelect) !== "" && (
            <li>
              {t("analyticsLegend.coveragesAre")} {hazardGaranzias(hazardSelect, KPISelect)}
            </li>
          )}
          <li>{t("analyticsLegend.bivariateOnlyNonZero")}</li>
        </ul>
      </div>
    </Grid>
  );
};
